import { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import IconHome from 'components/IconHome';
import IconNewsletter from 'components/IconNewsletter';

type FloatingMenuItemProps = {
  to: string;
  children: ReactNode;
};

export function FloatingMenuItem(
  props: FloatingMenuItemProps
): ReactElement<HTMLElement> {
  return (
    <Link to={props.to} className="mr-3 mb-3 block lg:mr-0 last:mb-0">
      <button className="h-12 w-12 border border-gray-300 rounded-full flex flex-row justify-center items-center bg-white focus:outline-none">
        {props.children}
      </button>
    </Link>
  );
}

function FloatingMenu(): ReactElement<HTMLElement> {
  return (
    <nav className="mb-2 w-full flex flex-row justify-center fixed bottom-0 z-10 lg:mt-5 lg:mr-10 lg:w-auto lg:block lg:top-0 lg:right-0">
      <FloatingMenuItem to="/">
        <IconHome />
      </FloatingMenuItem>
      <FloatingMenuItem to="/articles">
        <IconNewsletter />
      </FloatingMenuItem>
    </nav>
  );
}

export default FloatingMenu;
